// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/vendor/nucleo/css/nucleo.css'
import './assets/css/argon.min.css'
import './assets/scss/app.scss'
// import './assets/vendor/jquery/dist/jquery.min.js'
// import './assets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js'
// import './assets/js/argon.min.js'

import VueImageCompare from 'vue-image-compare';

Vue.use(VueImageCompare);

Vue.config.productionTip = false

Vue.use(BootstrapVue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js